import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/louve.module.scss';

const propTypes = {
    loading: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    loading: false,
    className: null,
};

const LouveIcon = ({ loading, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1155.7"
        height="1001.8"
        viewBox="0 0 1155.7 1001.8"
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.isLoading]: loading,
            },
        ])}
    >
        <path
            className={styles.withStroke}
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="30"
            d="M819.5,383.5s-172.3-96.4-379.5,33.3l29.9,25.6-93,31.6,17.9,19.6s-101.5,71.6-369.3,62.3c0,0,48.6,91.3,171.4,91.3s110.9-17.1,180.8-53.7c0,0-35,88.7-44.3,110.9-9.4,22.2-20.5,57.1-19.6,103.2s5.1,133.9,6,145,5.1,35,23,34.1,24.7-13.6,26.4-36.7c1.7-23,8.5-136.5,9.4-144.1.9-7.7,8.5-33.3,25.6-53.7,17.1-20.5,53.7-69.9,60.6-78.5,6.8-8.5,20.5-17.1,31.6-10.2,11.1,6.8,23.9,23,14.5,57.1s-23.9,57.1-12.8,86.1c11.1,29,108.3,152.7,117.7,164.6,9.4,11.9,25.6,14.5,34.1,9.4s10.2-17.9-2.6-40.1c-12.8-22.2-54.6-89.6-61.4-102.3-6.8-12.8-6.8-29.9,17.9-73.3,24.7-43.5,42.6-83.6,45.2-98.9l99.8-7.7-16.2,23,127.1-28.1,40.1,305.3c3.4,15.4,15.4,26.4,28.1,25.6,12.8-.9,22.2-8.5,21.3-30.7s-20.5-313.9-20.5-313.9c0,0,71.6-6,75.1,43.5,3.4,49.5,28.1,274.6,28.1,274.6,0,0,5.4,27.3,27.3,25.6,21.3-1.7,20.1-22.2,19.6-35.8-.9-23.9-4.3-414.5-4.3-414.5l47.8,22.2s-19.6-131.3-45.2-162l51.2,22.2s-40.1-100.6-64.8-135.6l40.9,15.4s-35.8-169.7-132.2-243.1c0,0-2.6,91.3-27.3,109.2l35.8,23.9-75.1,35.8,30.7,38.4s-59.7,6-110.9,6.8c-51.2.9-111.2,9.1-120.3-24.7s-2.6-29,25.6-40.9,60.6-25.6,69.9-42.6c9.4-17.1,21.3-21.3,29.9-29,8.5-7.7,22.9-22.2,24.7-45.2,2.6-31.6,4.3-47.8,4.3-47.8l48.6,56.3"
        />
    </svg>
);

LouveIcon.propTypes = propTypes;
LouveIcon.defaultProps = defaultProps;

export default LouveIcon;
